import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Gender } from '@core/models';
import { Observable } from 'rxjs';
import { MasterDataConfig, MASTER_DATA_CONFIG } from '../master-data.config';

@Injectable({
  providedIn: 'any'
})
export class MasterDataRemote {
  constructor(
    private http: HttpClient,
    @Inject(MASTER_DATA_CONFIG) private config: MasterDataConfig
  ) {}

  fetchGenders(): Observable<Gender[]> {
    return this.http.get<Gender[]>(this.config.REMOTE.GENDERS);
  }
}
